import { useState } from "react"
import { Link } from "react-router-dom"
import { Loader2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { AuthLayout } from "@/components/auth/AuthLayout"
import { FormAlert } from "@/components/auth/FormAlert"
import { authService } from "@/services/authService"

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState("")

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      await authService.forgotPassword(email)
      setSent(true)
    } catch {
      setError("Não foi possível enviar o e-mail. Tente novamente.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthLayout
      pageTitle="Recuperar senha"
      title="Esqueceu sua senha?"
      description="Informe o e-mail da sua conta e enviaremos as instruções para criar uma nova senha."
      footer={<Link to="/login" className="font-medium text-foreground underline underline-offset-2">Voltar ao login</Link>}
    >
      {sent ? (
        <FormAlert tone="success">
          Se este e-mail estiver cadastrado, você receberá as instruções em breve. Confira também a caixa de spam.
        </FormAlert>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email">E-mail</Label>
            <Input id="email" type="email" autoComplete="email" placeholder="voce@exemplo.com"
              value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </div>

          {error && <FormAlert>{error}</FormAlert>}

          <Button type="submit" size="lg" className="w-full" disabled={loading}>
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Enviando...</> : "Enviar instruções"}
          </Button>
        </form>
      )}
    </AuthLayout>
  )
}
